// modules
import { useCallback, useEffect, useRef } from 'react'
import { Recorder, config } from '@web-lite/voice-recorder'
import { Voice } from '@web-lite/voice-recorder/build/main/lib/types'
// helpers
import { RecorderStatus } from '../../../send-field.type'

config({
  wasmURL: '/assets/vmsg/vmsg.wasm',
  shimURL: '/assets/vmsg/wasm-polyfill.js',
})
const recorder = new Recorder()

export const useReactRecorder = ({
  state,
  setRecorderState,
  setRecorderVoice,
}: {
  state: RecorderStatus
  setRecorderState: (newState: RecorderStatus) => unknown
  setRecorderVoice: (voice: any) => unknown
}) => {
  const recording = state === 'PRESSED' || state === 'RECORD'

  const MIN_DURATION = 1000

  const isAlreadyRecording = useRef<boolean>(false)

  const onRecordStart = useCallback(() => {
    setRecorderState('RECORD')
  }, [])

  const onRecordStop = useCallback((voice: Voice) => {
    if (voice.duration < MIN_DURATION) setRecorderState('IDLE')
    else {
      setRecorderState('PLAYING')
      setRecorderVoice(voice)
    }
  }, []) // TODO: check this dependency on voice upload

  useEffect(() => {
    if (!recording) {
      recorder
        .stop()
        .then(v => {
          isAlreadyRecording.current = false
          onRecordStop(v)
        })
        .catch((error: any) =>
          // eslint-disable-next-line no-console
          console.log('Error occurred when stopping recording:', error),
        )
    } else if (recording) {
      recorder
        .start()
        .then(() => {
          onRecordStart()
          isAlreadyRecording.current = true
        })
        .catch((error: any) =>
          // eslint-disable-next-line no-console
          console.log('Error occurred when starting recording:', error),
        )
    }
  }, [recording])

  useEffect(() => {
    return () => {
      if (isAlreadyRecording.current) {
        recorder.stop()
      }
    }
  }, [])
}
